import { Link, useLocation } from "react-router-dom";
import { Instagram, MessageCircle, Mail } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  const waLink = `https://wa.me/${SITE.whatsappNumber}`;
  const location = useLocation();
  const isHome = location.pathname === "/";
  const nav = (hash) => (isHome ? `#${hash}` : `/#${hash}`);

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/brand/nexaverve-logo-dark.svg"
              alt="Nexaverve Solutions"
              className="h-16 sm:h-20 w-auto object-contain"
            />
            <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">
              Manchester-based facilities consultancy and cleaning crew.
              Compliance, maintenance and standards — under one roof.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="tag-label mb-4">Navigate</p>
            <ul className="space-y-3 text-neutral-300">
              <li><a className="hover:text-[#FBBF24] transition-colors" href={nav("services")} data-testid="footer-nav-services">Services</a></li>
              <li><a className="hover:text-[#FBBF24] transition-colors" href={nav("about")} data-testid="footer-nav-about">About</a></li>
              <li><a className="hover:text-[#FBBF24] transition-colors" href={nav("process")} data-testid="footer-nav-process">Process</a></li>
              <li><a className="hover:text-[#FBBF24] transition-colors" href={nav("contact")} data-testid="footer-nav-contact">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="tag-label mb-4">Get in touch</p>
            <ul className="space-y-3">
              <li>
                <a href={waLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 text-neutral-300 hover:text-[#FBBF24] transition-colors">
                  <MessageCircle className="w-4 h-4" /> {SITE.whatsappPretty}
                </a>
              </li>
              <li>
                <a href={SITE.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 text-neutral-300 hover:text-[#FBBF24] transition-colors">
                  <Instagram className="w-4 h-4" /> @{SITE.instagramHandle}
                </a>
              </li>
              <li>
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="inline-flex items-center gap-2 text-neutral-300 hover:text-[#FBBF24] transition-colors">
                  <Mail className="w-4 h-4" /> {SITE.email}
                </a>
              </li>
            </ul>
            <p className="mt-5 text-sm text-neutral-500">{SITE.location}</p>
          </div>
        </div>

        {/* Big watermark */}
        <div
          aria-hidden
          className="mt-16 select-none pointer-events-none font-display font-black text-[18vw] sm:text-[14vw] leading-none tracking-tighter text-white/[0.04] text-center"
        >
          NEXAVERVE
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-600">
            © {year} {SITE.name} · {SITE.domain}
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500 hover:text-[#FBBF24] transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500 hover:text-[#FBBF24] transition-colors"
            >
              Terms of Service
            </Link>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-600">
              Designed & built for the North West
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
